import { useServerSentEvent } from "../useServerSentEvent.js";
import { ServerSentResourceType } from "../../type/InternalServerSentEvents.js";
import "react";
import "../../constants/serverSentEvents/serverSentEvents.js";
const useAnamnesisSSE = (callback) => {
  useServerSentEvent(ServerSentResourceType.ANAMNESIS, "CREATED", callback);
  useServerSentEvent(ServerSentResourceType.ANAMNESIS, "UPDATED", callback);
};
export {
  useAnamnesisSSE
};
